var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 93,
    viewBox: "0 0 72 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.096 88L14.86 80.72H14.808C14.8167 80.8933 14.8297 81.1533 14.847 81.5C14.8643 81.8467 14.8817 82.2193 14.899 82.618C14.9163 83.008 14.925 83.3633 14.925 83.684V88H13.17V78.718H15.848L18.045 85.816H18.084L20.411 78.718H23.089V88H21.256V83.606C21.256 83.3113 21.2603 82.9733 21.269 82.592C21.2863 82.2107 21.2993 81.851 21.308 81.513C21.3253 81.1663 21.3383 80.9063 21.347 80.733H21.295L18.903 88H17.096ZM30.7897 88L30.1137 85.79H26.7337L26.0577 88H23.9387L27.2147 78.679H29.6197L32.9087 88H30.7897ZM28.9697 81.981C28.9263 81.8337 28.87 81.6473 28.8007 81.422C28.7313 81.1967 28.662 80.967 28.5927 80.733C28.5233 80.499 28.467 80.2953 28.4237 80.122C28.3803 80.2953 28.3197 80.512 28.2417 80.772C28.1723 81.0233 28.103 81.266 28.0337 81.5C27.973 81.7253 27.9253 81.8857 27.8907 81.981L27.2277 84.139H29.6457L28.9697 81.981ZM41.2213 88H38.9853L36.5543 84.087L35.7223 84.685V88H33.7593V78.718H35.7223V82.969C35.8523 82.787 35.9823 82.605 36.1123 82.423C36.2423 82.241 36.3723 82.059 36.5023 81.877L39.0113 78.718H41.1953L37.9583 82.826L41.2213 88ZM47.4101 88H42.0671V78.718H47.4101V80.33H44.0301V82.371H47.1761V83.983H44.0301V86.375H47.4101V88ZM56.5695 84.724C56.5695 85.3653 56.4265 85.946 56.1405 86.466C55.8632 86.9773 55.4385 87.3847 54.8665 87.688C54.3032 87.9827 53.5882 88.13 52.7215 88.13C51.4908 88.13 50.5548 87.818 49.9135 87.194C49.2722 86.5613 48.9515 85.7293 48.9515 84.698V78.718H50.9145V84.399C50.9145 85.1617 51.0705 85.699 51.3825 86.011C51.6945 86.323 52.1582 86.479 52.7735 86.479C53.2068 86.479 53.5578 86.4053 53.8265 86.258C54.0952 86.1107 54.2902 85.881 54.4115 85.569C54.5415 85.257 54.6065 84.8627 54.6065 84.386V78.718H56.5695V84.724ZM61.4817 78.718C62.6777 78.718 63.5487 78.978 64.0947 79.498C64.6493 80.0093 64.9267 80.7157 64.9267 81.617C64.9267 82.0243 64.866 82.4143 64.7447 82.787C64.6233 83.151 64.4197 83.4803 64.1337 83.775C63.8563 84.061 63.488 84.2863 63.0287 84.451C62.5693 84.6157 62.0017 84.698 61.3257 84.698H60.4807V88H58.5177V78.718H61.4817ZM61.3777 80.33H60.4807V83.086H61.1307C61.5033 83.086 61.824 83.0383 62.0927 82.943C62.3613 82.8477 62.5693 82.696 62.7167 82.488C62.864 82.28 62.9377 82.0113 62.9377 81.682C62.9377 81.2227 62.812 80.8847 62.5607 80.668C62.3093 80.4427 61.915 80.33 61.3777 80.33Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7504 33.5615H47.1866C48.5984 33.5615 49.9963 33.8382 51.3006 34.3756C52.6049 34.9131 53.79 35.7009 54.7883 36.694C55.7866 37.6871 56.5784 38.8661 57.1187 40.1636C57.6589 41.4612 57.937 42.8519 57.937 44.2563V55.0922C57.937 55.8401 57.6384 56.5573 57.1068 57.0862C56.5752 57.615 55.8542 57.9121 55.1024 57.9121H16.8346C16.0829 57.9121 15.3618 57.615 14.8302 57.0862C14.2986 56.5573 14 55.8401 14 55.0922V44.2563C14 41.4199 15.1326 38.6996 17.1487 36.694C19.1648 34.6883 21.8992 33.5615 24.7504 33.5615Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4575 35.2395V25.1157H25.8418V33.0046",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8346 25.1228H18.4575L15.1764 16.6628C17.0694 14.9658 19.5224 14.0185 22.0705 14.0003C24.6187 13.9821 27.0851 14.8943 29.0024 16.5641L29.1157 16.6628L25.8346 25.1228Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3385 29.3457H18.9606",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3339 33.3571V27.2307H35.848V33.0046",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5433 30.0507H31.6456",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0717 33.0046V24.4106H44.8197V33.0046",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4937 27.2307H40.3905",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6086 26.7794V17.262",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6953 18.7848H35.4016",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6953 21.4286H35.4016",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6953 24.0723H35.4016",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5425 21.4638C45.5425 24.0935 44.1251 24.2838 42.4456 24.2838C40.7661 24.2838 39.3417 24.1217 39.3417 21.4638C39.3417 18.806 40.759 14.7382 42.4456 14.7382C44.1322 14.7382 45.5425 18.8342 45.5425 21.4638Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6489 44.1506C45.6489 44.1506 42.2048 45.765 36.0252 45.8637C29.9449 45.6663 26.4016 44.1506 26.4016 44.1506C27.1232 44.1305 27.8385 44.0119 28.5276 43.7981C29.2363 43.495 29.945 42.7195 31.6174 41.6831C32.3092 41.2845 33.1085 41.1098 33.9045 41.183C34.7006 41.2563 35.4541 41.5739 36.0607 42.092C36.6337 41.5617 37.3615 41.2266 38.1387 41.1354C38.9159 41.0441 39.7022 41.2014 40.3835 41.5844C42.2544 42.6419 43.0197 43.4456 43.6788 43.7487C44.3145 43.9697 44.9771 44.1048 45.6489 44.1506Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6489 44.1506C45.6489 44.1506 43.6221 45.8638 42.963 46.6252C42.1298 47.6749 41.0786 48.5332 39.8812 49.1416C38.6838 49.75 37.3685 50.094 36.0252 50.1502C32.0142 50.0656 30.1505 47.3796 29.1371 46.4701C28.1237 45.5607 26.4016 44.1506 26.4016 44.1506",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8448 33.4769L48.9299 22.486C48.9276 22.212 48.9907 21.9414 49.1138 21.6963C49.237 21.4512 49.4169 21.2386 49.6385 21.076C50.1657 20.7218 50.7915 20.5413 51.4273 20.5603C52.0632 20.5793 52.677 20.7967 53.1819 21.1818C53.3962 21.3484 53.5681 21.5629 53.6838 21.8078C53.7995 22.0527 53.8558 22.3212 53.848 22.5917V35.8387",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeupicon);
export default __webpack_public_path__ + "static/media/makeupicon.17191937eb811932592becef5e0e07e5.svg";
export { ForwardRef as ReactComponent };